/**
 * @module helpers/date-helper
 */

import { MONTHS, DAYS, SHORT_MONTHS } from 'shared_js/constants/dates';

/**
 * Returns human readable timestamp format
 *
 * @example
 * humanizeTimestamp('2017-06-23T14:15:53.886+07:00', '%day% %dd% %mmm% %yyyy% - %hh%:%mi% WIB')
 * // => Jumat 23 Jun 2017 - 14:15 WIB
 *
 * @param  {String} timestamp timestamp format
 * @param  {String} format specific wanted format to humanize the timestamp (in-casesensitive)
 *
 * @return {String}
 */
function humanizeTimestamp(timestamp, format = '%day%, %dd% %month% %yyyy%') {
  const dateTime = new Date(timestamp);

  if (!(timestamp && dateTime.getTime())) return '';

  const timeMapping = {
    '%hh%': `0${dateTime.getHours()}`.slice(-2),
    '%mi%': `0${dateTime.getMinutes()}`.slice(-2),
    '%ss%': `0${dateTime.getSeconds()}`.slice(-2),
    '%d%': dateTime.getDate(),
    '%dd%': `0${dateTime.getDate()}`.slice(-2),
    '%day%': DAYS[dateTime.getDay()],
    '%mm%': `0${dateTime.getMonth() + 1}`.slice(-2),
    '%mmm%': SHORT_MONTHS[dateTime.getMonth()],
    '%month%': MONTHS[dateTime.getMonth()],
    '%yy%': `${dateTime.getYear()}`.slice(-2),
    '%yyyy%': dateTime.getFullYear(),
  };
  return format.replace(/%(.*?)%/gi, n => timeMapping[n]);
}

export default humanizeTimestamp;
